<template>
  <section class="reset-password-screen">
    <el-col :md="12" :lg="10" :sm="24" :xs="24" :xl="10" class="login-screens-right">
      <section class="reset-password-form">
        <AuthNutronMobileLogo />
        <h3 class="form-title">Reset Password</h3>
        <el-form
          ref="form"
          :model="reset_password"
          class="login-forms"
          @keyup.enter.native="onSubmit"
        >
          <el-row>
            <el-col :md="24">
              <el-form-item class="mb-0" label="Enter OTP">
                <el-input v-model="reset_password.otp" placeholder="Enter OTP" autofocus></el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors['otp']"
                >{{ this.getErrors['otp'] }}</span>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <div class="reset-password forgot-password">
                <p>Enter OTP which is sent to your registered email.</p>
                <span class="error" v-if="getErrors && getErrors['otp']">{{ this.getErrors['otp'] }}</span>
              </div>
            </el-col>
            <el-col :md="24">
              <el-form-item label="Enter New Password">
                <el-input v-model="reset_password.password" placeholder="Enter New Password"></el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors['password']"
                >{{ this.getErrors['password'] }}</span>
              </el-form-item>
            </el-col>

            <el-col :md="24">
              <el-form-item>
                <el-button
                  type="primary"
                  @click="onSubmit"
                  :loading="loading"
                  class="btn submit-btn"
                >Change Password</el-button>
                <div class="form-navigation">
                  <router-link to="/forgot-password">OTP not received ? Resend OTP</router-link>
                </div>
              </el-form-item>
            </el-col>
            <span class="error" v-if="getErrors && getErrors['error']">{{ this.getErrors['error'] }}</span>
          </el-row>
        </el-form>
        <div class="mobile-copyright hidden-md-and-up">
          <el-row>
            <el-col :xl="24">
              <p>
                Copyright © 2019
              </p>
            </el-col>
            <el-col :xl="24">
              <p>
                Powered by
                <a href="https://orotron.com/" target="_blank">OROTRON</a>
              </p>
            </el-col>
          </el-row>
        </div>
      </section>
    </el-col>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import AuthenticationLayout from "../../layouts/AuthenticationLayout.vue";
import AuthNutronMobileLogo from "./AuthNutronMobileLogo";

export default {
  name: "reset-password",
  components: {AuthNutronMobileLogo},
  data() {
    return {
      loading: false,
      reset_password: {
        otp: "",
        password: "",
        password_confirmation: "",
        username: ""
      }
    };
  },
  created() {
    this.$emit("update:layout", AuthenticationLayout);
    this.$root.$emit('closenav', false);

  },
  computed: {
    ...mapGetters("errors", ["getErrors"]),
    ...mapGetters("auth", ["getOtpStatus", "getResetStatus"])
  },
  methods: {
    async onSubmit() {
      this.reset_password.password_confirmation = this.reset_password.password;
      this.reset_password.username = this.$route.query.username;
      this.loading = true;
      await this.$store.dispatch("auth/resetPassword", this.reset_password);
      this.loading = false;
      // console.log(this.getResetStatus);
      if (this.getResetStatus.success) {
        this.$router.push({ name: "signin" });
      }
    }
  }
};
</script>

